import { render, staticRenderFns } from "./authenticated.vue?vue&type=template&id=71c1feb6&"
import script from "./authenticated.vue?vue&type=script&lang=ts&"
export * from "./authenticated.vue?vue&type=script&lang=ts&"
import style0 from "./authenticated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports